'use client';

import type { ChangeEvent } from 'react';
import type { UriType } from '~/model/GlobalTypes';
import { VpButton, VpFormControl, VpFormHelper, VpFormLabel, VpTextarea } from '@vtmn-play/react/headless';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { fetchItem } from '@/app/actions/server';
import { MailSuccess } from '@/app/components/Discussion/ReportCommentAbuse/MailSuccess';
import { GenericDialog } from '~/components/commons/genericDialog/GenericDialog';
import { EventCode } from '~/model/MailType';
import { convertLinebreaksForMail } from '~/utils/utils';

export const InteractionContactDialog = ({
  interactionUri,
  handleOpen,
  open = false,
}: {
  interactionUri: UriType;
  handleOpen: (value: boolean) => void;
  open?: boolean;
}) => {
  const t = useTranslations();

  const [body, setBody] = useState('');
  const [hasPosted, setHasPosted] = useState(false);
  const [loading, setLoading] = useState(false);

  const closeModal = (): void => {
    handleOpen(false);
    setBody('');
    setHasPosted(false);
    setLoading(false);
  };

  const handleSubmit = async () => {
    setLoading(true);

    await fetchItem({
      pathname: 'send_mail',
      method: 'POST',
      body: {
        eventCode: EventCode.contact_interaction_manager,
        attributes: {
          MESSAGE: convertLinebreaksForMail(body),
        },
        interaction: interactionUri,
      },
    });

    setHasPosted(true);
    setLoading(false);
  };

  const handleInputTextChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    setBody(e.target.value);
  };

  const canBeSubmitted: boolean = body.length > 0;

  const content = (
    <div className="popin contact-popin">
      {hasPosted
        ? (
            <MailSuccess closeModal={closeModal} />
          )
        : (
            <>
              <div className="row">
                <div className="col form-group">
                  <VpFormControl required>
                    <VpFormLabel>{t('CONTACT.FORM.BODY_PLACEHOLDER')}</VpFormLabel>
                    <VpTextarea
                      id="body"
                      name="body"
                      value={body}
                      onChange={handleInputTextChange}
                      placeholder={t('CONTACT.FORM.BODY_PLACEHOLDER')}
                      maxLength={2000}
                    />
                    <VpFormHelper>{t('DISCUSSION.CHARACTERS_MAX')}</VpFormHelper>
                  </VpFormControl>
                </div>
              </div>
              <div className="text-center">
                <VpButton
                  id="submit-contact"
                  type="submit"
                  disabled={!canBeSubmitted}
                  onClick={handleSubmit}
                >
                  {t('GLOBAL.SEND')}
                </VpButton>
              </div>
            </>
          )}
    </div>
  );

  return (
    <GenericDialog
      isOpen={open}
      isClosable
      onClose={closeModal}
      content={content}
      isLoading={loading}
      title={t('GLOBAL.CONTACT_US')}
    />
  );
};
